                    /*
                     * Invitación a la app (Reskyt) — cambio del 03/11/2026, decidido por Juan.
                     * Objetivo: que la home no pida nada al entrar (solo cookies) y que la app siga enlazada sin ventanas.
                     *  - Barra: solo Android, desde la 2.ª página vista de la sesión, en cualquier página (antes: iOS y Android, solo home, al cargar).
                     *  - iPhone: sin barra propia; lo cubre el banner nativo de Apple (meta apple-itunes-app en layout/theme.liquid).
                     *  - Menú móvil: enlace fijo «Descarga la app» al final del cajón (kdrawer), insertado aquí para no reescribir snippets/header-drawer.liquid.
                     *  - Nada de esto se muestra dentro de la app (user agent rktwebview o cookie is_app_install_bar).
                     *  - 03/11/2026: rediseño con botón «INSTALAR» (placa docs/placa_cta_app.html); la barra es flex y ya no muestra la tienda en texto.
                     * Original antes de los cambios: tema BACKUP 194143584631, assets/download-bar.js md5 b4a407a7ac50d5f4677d3c0a7485a257.
                     */
                    function closeBar () {
                        dias_expire = 7; /*Dias que queremos que pasen hasta que se vuelva a mostrar la barra*/
                        setCookie("reskyt-install-app", 1, dias_expire);
                        var bar = document.getElementById("href-download-app");
                        bar.style.display = "none";
                        bar.classList.remove("is-visible"); /* devuelve la pestaña del 10 % a su sitio */
                        return false;
                    }
                    function setCookie(cname, cvalue, exdays) {
                        var d = new Date();
                        d.setTime(d.getTime() + (exdays*24*60*60*1000));
                        var expires = "expires="+ d.toUTCString();
                        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; /*Añadir ;SameSite=None;Secure en caso de que la cookie tenga que ser accesible entre iFrame*/
                    }
                    function getCookie(cname) {
                        var name = cname + "=";
                        var decodedCookie = decodeURIComponent(document.cookie);
                        var ca = decodedCookie.split(';');
                        for(var i = 0; i <ca.length; i++) {
                            var c = ca[i];
                            while (c.charAt(0) == ' ') {
                                c = c.substring(1);
                            }
                            if (c.indexOf(name) == 0) {
                                return c.substring(name.length, c.length);
                            }
                        }
                        return "";
                    }
                    var url = window.location.href;
                    if ( url.indexOf("customapp=") != -1 ) {
                        setCookie("is_app_install_bar", 1, 365);
                    }

                    /* Páginas vistas en la sesión (la barra sale desde la 2.ª). Si el navegador bloquea sessionStorage, cuenta como 1.ª. */
                    var krsPageViews = 1;
                    try {
                        krsPageViews = parseInt(sessionStorage.getItem("krs_pv") || "0", 10) + 1;
                        sessionStorage.setItem("krs_pv", String(krsPageViews));
                    } catch (e) {}

                    window.addEventListener("DOMContentLoaded", function () {
                        var ua = navigator.userAgent;
                        var inApp = /rktwebview/i.test(ua) || !!getCookie("is_app_install_bar");
                        var isAndroid = /Android/i.test(ua);
                        var isIOS = /iPhone|iPad|iPod/i.test(ua);

                        var bar = document.getElementById("href-download-app");
                        if (bar) {
                            var showBar = !inApp && isAndroid && krsPageViews >= 2 && !getCookie("reskyt-install-app");
                            bar.style.display = showBar ? "flex" : "none";
                            bar.classList.toggle("is-visible", showBar); /* la sección sube la pestaña del 10 % (Omnisend) por encima de la barra */
                        }

                        /* Enlace «Descarga la app» al final del menú móvil */
                        var tpl = document.getElementById("krs-app-menu-tpl");
                        var drawer = document.querySelector("header-drawer .kdrawer");
                        if (!inApp && (isAndroid || isIOS) && tpl && drawer && !drawer.querySelector(".kdrawer__app")) {
                            var node = tpl.content.firstElementChild.cloneNode(true);
                            var panels = drawer.querySelector(".kdrawer__panels");
                            if (panels && panels.parentNode === drawer) {
                                panels.insertAdjacentElement("afterend", node);
                            } else {
                                drawer.appendChild(node);
                            }
                        }
                    });
